$.Velocity.RegisterEffect('transition.floorUpIn', {
  defaultDuration: 1500,
  calls: [
      [ { opacity: [1, 0], scale: [1, 0.5], transformOrigin: '50% 50%' } ]
  ],
  reset: { scale: 1 }
}).RegisterEffect('transition.floorDownIn', {
  defaultDuration: 1500,
  calls: [
    [ { opacity: [1, 0], scale: [1, 2], transformOrigin: '50% 50%' } ]
  ],
  reset: { scale: 1 }
})
.RegisterEffect('transition.floorUpOut', {
  defaultDuration: 1500,
  calls: [
    [ { opacity: [0, 1], scale: [2, 1], transformOrigin: '50% 50%' } ] // transition.floorUpOut
  ],
  reset: { scale: 1 }
}).RegisterEffect('transition.floorDownOut', {
  defaultDuration: 1500,
  calls: [
    [ { opacity: [0, 1], scale: [0.5, 1], transformOrigin: '50% 50%' } ]
  ],
  reset: { scale: 1 }
});
